import withFont, { FONT_ROBOTO_CONDENSED } from '../util/Font'

import Figure from './Figure'

export default withFont(Figure, FONT_ROBOTO_CONDENSED, 'NBBFigure')
